import { Config } from '@/utils/config';

const HTTP_URL_PATTERN = /https?:\/\/([^/?#]+)/i;

const toHostname = (value: string) => {
  try {
    return new URL(value).hostname;
  } catch {
    return value.match(HTTP_URL_PATTERN)?.[1] ?? '';
  }
};

export const shouldIgnoreTraceUrl = (url: string) => {
  const hostname = toHostname(url).toLowerCase();
  if (!hostname) return false;

  return Config.SENTRY.TRACE_IGNORE_HOSTS.some(
    (host) => hostname === host || hostname.endsWith(`.${host}`),
  );
};

export const shouldCreateSpanForRequest = (url: string) => !shouldIgnoreTraceUrl(url);

export const sentryTracePropagationTargets = (): Array<string | RegExp> => {
  const targets: Array<string | RegExp> = ['localhost', /^\//];

  for (const url of [Config.NEST_URL, Config.NEXT_URL]) {
    if (!url) continue;
    try {
      targets.push(new URL(url).origin);
    } catch {
      // Env values are origins in production; skip malformed local overrides.
    }
  }

  return targets;
};
